import React from 'react'
import './Title.scss'

interface IProps {
  title: string
  description?: string | React.ReactElement
  className?: string
}

export function Title({ title, description, className }: IProps) {
  return (
    <div className={`arc-title ${className}`}>
      <h1 className="arc-title__title">{title}</h1>
      {description && <p className="arc-title__description">{description}</p>}
    </div>
  )
}
